import React from 'react';
import "../css/bootstrap.css"
import "../css/app.css"
import "../css/fas.css"

export const Navigation = ({changeFunc}) => {
    return (
        <div className="container d-flex justify-content-center nav">
            <div className="col-lg-7">
                <div className="row d-flex justify-content-center">
                <div className="tabs"><button onClick={(e) => {changeFunc(1)}}><i className="fa fa-home" aria-hidden="true"></i></button></div>
                <div className="tabs"><button onClick={(e) => {changeFunc(2)}}>About</button></div>
                <div className="tabs"><button onClick={(e) => {changeFunc(4)}}>Projects</button></div>
                <div className="tabs"><button onClick={(e) => {changeFunc(5)}}>Posts</button></div>
                <div className="tabs"><button onClick={(e) => {changeFunc(3)}}><i className="fa fa-envelope" aria-hidden="true"></i></button></div>
                </div>
            </div>
        </div>
    )
}    